import type { APIError } from "src/types";

export function fieldToError(key: string, message: string): APIError {
  return {
    key,
    message,
    arguments: [],
  };
}
